import { checkCrops } from "api/checkCrops";
import { useMutation } from "react-query";

export const useCheckCrops = () => useMutation(() => checkCrops());